import './PageSettings.scss';
import HeaderLine from "../../components/headerLine/HeaderLine";
import FormBorder from '../../components/formBorder/FormBorder';
import FormSettings from '../../components/forms/settings/FormSettings';

export default function PageSettings(props) {
    return (
        <div className='page-settings fullpage'>
            <HeaderLine selectedPage='settings' />
            <main className='page-settings-main'>
                <div className='page-settings-form'>
                    <FormBorder form={<FormSettings />} />
                </div>
            </main>
        </div>)
}
